import type { NodePropertySchema } from '../../../types/node-properties';

const schema: NodePropertySchema = {
  nodeType: 'turso',
  version: '1.0.0',
  properties: [
    {
      key: 'credentialId',
      label: 'Turso Credentials',
      type: 'credential',
      required: true,
      typeOptions: {
        credentialType: 'turso',
      },
      description: 'Select Turso database credentials',
    },
    {
      key: 'operation',
      label: 'Operation',
      type: 'options',
      required: true,
      default: 'executeQuery',
      options: [
        { value: 'executeQuery', name: 'Execute Query (SELECT)' },
        { value: 'executeStatement', name: 'Execute Statement (INSERT/UPDATE/DELETE)' },
        { value: 'batch', name: 'Batch Execution' },
      ],
      description: 'Type of database operation to perform',
    },
    {
      key: 'query',
      label: 'SQL Query',
      type: 'string',
      required: true,
      typeOptions: {
        rows: 5,
        editor: 'code',
        editorLanguage: 'sql',
      },
      placeholder: 'SELECT * FROM users WHERE email = ? AND status = ?',
      description: 'SQL query to execute. Use ? for parameter placeholders to prevent SQL injection.',
    },
    {
      key: 'parameters',
      label: 'Query Parameters',
      type: 'json',
      required: false,
      placeholder: '["user@example.com", "active"]',
      description: 'Array of values for ? placeholders in the query (e.g., ["value1", "value2"])',
    },
    {
      key: 'returnFirst',
      label: 'Return First Row Only',
      type: 'boolean',
      default: false,
      description: 'Return only the first result row instead of all rows',
      displayOptions: {
        show: {
          operation: ['executeQuery'],
        },
      },
    },
    {
      key: 'queries',
      label: 'Batch Queries',
      type: 'json',
      required: false,
      placeholder: '[{"sql": "INSERT INTO users (name) VALUES (?)", "args": ["John"]}, {"sql": "UPDATE users SET status = ? WHERE id = ?", "args": ["active", 1]}]',
      description: 'Array of query objects with sql and args properties',
      displayOptions: {
        show: {
          operation: ['batch'],
        },
      },
    },
  ],
};

export default schema;
